<template>
  <div v-if="abSaleData">
    <el-popover
      placement="top"
      width="300"
      trigger="hover"
      :content="popoverContent"
      :disabled="!abSaleData"
    >
      <div slot="reference">
        <el-switch
          v-model="switchValue"
          :active-value="1"
          :inactive-value="2"
          @change="handleSwitchChange"
        />
      </div>
      <div>
        <div>
          <div>
            商品ID: {{ abSaleData.relateSaleId }}
            <a
              :href="abSaleData.previewUrl"
              target="_blank"
              class="text-[#409eff] ml-2"
              >预览</a
            >
          </div>
          <div class="mt-2 text-[#999]">选品：{{ abSaleData.chooser }} 设计：{{ abSaleData.designer }}</div>
        </div>
      </div>
    </el-popover>
  </div>
  <span v-else>--</span>
</template>

<script>
import { editAbStatus } from '@/api/google/adManagement';
import { guardOwner } from '@/utils/ownerGuard';

export default {
  name: 'AbSaleCell',
  props: {
    row: {
      type: Object,
      required: true,
    },
    abSaleMap: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    abSaleData() {
      return this.abSaleMap[this.row.campaign_id];
    },
    switchValue: {
      get() {
        return this.abSaleData?.status || 2;
      },
      set(val) {
        // 用于v-model绑定
      },
    },
    popoverContent() {
      if (!this.abSaleData) return '';
      return `${this.abSaleData.relateSaleId} 选品：${this.abSaleData.chooser} 设计：${this.abSaleData.designer}`;
    },
  },
  methods: {
    async handleSwitchChange(status) {
      if (!(await guardOwner(this.row))) {
        this.$forceUpdate();
        return;
      }
      try {
        const params = {
          saleId: this.abSaleData.saleId,
          status: status,
          utmSourceConfig: this.abSaleData.utmSourceConfig || '',
        };

        const res = await editAbStatus(params);

        if (res.code === 0) {
          this.$set(this.abSaleMap[this.row.campaign_id], 'status', status);
          this.$message({
            type: 'success',
            message: status === 1 ? 'AB品已开启' : 'AB品已关闭',
          });
        } else {
          throw new Error(res.message || '操作失败');
        }
      } catch (error) {
        this.$message({
          type: 'error',
          message: error.message || '操作失败，请重试',
        });
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.giikin-popup {
  font-size: 12px;
  line-height: 1.5;
}
.giikin-popup a {
  color: #409eff;
  text-decoration: none;
}
.giikin-popup a:hover {
  text-decoration: underline;
}
</style>
